/**
 * ENVIRONMENT & INSTITUTIONS (sidenav scrolled)
 */

const sideNav = () => {
  const navLinks: NodeListOf<HTMLAnchorElement> = document.querySelectorAll('.env-inst__menu-link');
  const sections: NodeListOf<HTMLElement> = document.querySelectorAll('.env-inst__section');

  const onScroll = (): void => {
    const scrollPosition: number = window.scrollY + window.innerHeight / 2;

    sections.forEach((section: HTMLElement) => {
      const sectionTop: number = section.offsetTop;
      const sectionHeight: number = section.offsetHeight;

      if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
        navLinks.forEach((link: HTMLAnchorElement) => {
          link.classList.remove('active');
          if (section.getAttribute('id') === link.getAttribute('href')?.substring(1)) {
            link.classList.add('active');
          }
        });
      }
    });
  };

  window.addEventListener('scroll', onScroll);
  onScroll(); // Initialize the active class on page load
};

export default sideNav;